(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tipo-ordenamiento', {
            parent: 'entity',
            url: '/tipo-ordenamiento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.tipoOrdenamiento.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamientos.html',
                    controller: 'TipoOrdenamientoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoOrdenamiento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tipo-ordenamiento-detail', {
            parent: 'tipo-ordenamiento',
            url: '/tipo-ordenamiento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.tipoOrdenamiento.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-detail.html',
                    controller: 'TipoOrdenamientoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoOrdenamiento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TipoOrdenamiento', function($stateParams, TipoOrdenamiento) {
                    return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tipo-ordenamiento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tipo-ordenamiento-detail.edit', {
            parent: 'tipo-ordenamiento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html',
                    controller: 'TipoOrdenamientoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TipoOrdenamiento', function(TipoOrdenamiento) {
                            return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tipo-ordenamiento.new', {
            parent: 'tipo-ordenamiento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html',
                    controller: 'TipoOrdenamientoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tipo-ordenamiento', null, { reload: 'tipo-ordenamiento' });
                }, function() {
                    $state.go('tipo-ordenamiento');
                });
            }]
        })
        .state('tipo-ordenamiento.edit', {
            parent: 'tipo-ordenamiento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html',
                    controller: 'TipoOrdenamientoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TipoOrdenamiento', function(TipoOrdenamiento) {
                            return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tipo-ordenamiento', null, { reload: 'tipo-ordenamiento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tipo-ordenamiento.delete', {
            parent: 'tipo-ordenamiento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-delete-dialog.html',
                    controller: 'TipoOrdenamientoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TipoOrdenamiento', function(TipoOrdenamiento) {
                            return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tipo-ordenamiento', null, { reload: 'tipo-ordenamiento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
